export function timeToMilliseconds(days, hours, min, sec) {
  return (60 * 60 * 24 * days + hours * 60 * 60 + min * 60 + sec) * 1000;
}
